// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Typography, TextareaAutosize } from '@material-ui/core';

// Internal Dependencies
import Images from '../../basics/Images';

const MapboundCallout = ({ heading, title, content, setTitle, setContent }) => (
  <div className="mb-3">
    <Typography variant="h6">{heading}</Typography>
    <Typography variant="subtitle1" color="inherit" style={{ maxWidth: heading === 'Deals Map' ? '360px' : '390px' }}>
      Enter the title and content that will be shown in
      {' '}
      {heading}
      {' '}
      for the geographic boundary
    </Typography>

    <div className="geographic_boundary__formContentContainer">
      <div className="geographic_boundary__formContentSubContainer">
        <div className="mt-3">
          <h6>Title (Max 2 lines and 100 characters)</h6>
          <TextareaAutosize
            variant="outlined"
            rowsMax={2}
            maxLength={100}
            style={{
              fontSize:     '13px',
              width:        '100%',
              borderRadius: '4px',
              padding:      '12px',
            }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => {
              const text = e.target.value;
              const rows = text.split('\n').length;
              if (rows >= 2 && e.key === 'Enter') {
                e.preventDefault(); // Prevent the default behavior if the input already has 2 lines of text
              }
            }}
          />
        </div>

        <div className="mt-3">
          <h6 className="mb-2">Content (Max 100 characters)</h6>
          <TextareaAutosize
            variant="outlined"
            rowsMin={6}
            maxLength={100}
            style={{
              fontSize:     '13px',
              width:        '100%',
              borderRadius: '4px',
              padding:      '12px',
            }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '65%' }}>
        <img
          // eslint-disable-next-line global-require
          src={Images.Local.SampleAreaMarker}
          alt="map"
          style={{ width: '300px', height: '250px', objectFit: 'cover' }}
        />
        <Typography style={{ textAlign: 'center', fontStyle: 'italic' }} variant="subtitle1" color="inherit">Example</Typography>
      </div>
    </div>
  </div>
);

export default MapboundCallout;

MapboundCallout.propTypes = {
  heading:    PropTypes.string.isRequired,
  title:      PropTypes.string.isRequired,
  content:    PropTypes.string.isRequired,
  setTitle:   PropTypes.func.isRequired,
  setContent: PropTypes.func.isRequired,
};
